/**
 * logger — Canal único de diagnóstico del frontend.
 *
 * QUÉ HACE: expone error/warn/info/log como envoltorio tipado de la consola,
 *   para que ningún módulo llame a `console` directamente (regla de lint
 *   `no-console`) y exista un solo punto donde centralizar o silenciar la
 *   salida de diagnóstico.
 * QUÉ INVOCA: `console` (único archivo autorizado a hacerlo).
 * QUÉ EXPORTA: `logger`.
 * QUÉ NO DEBE HACER: no persiste, no envía datos a red ni conoce negocio.
 */
/* eslint-disable no-console -- único punto autorizado de salida a consola */
export const logger = {
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  info: (...args: unknown[]): void => {
    console.info(...args);
  },
  log: (...args: unknown[]): void => {
    console.log(...args);
  },
  group: (...args: unknown[]): void => {
    console.group(...args);
  },
  groupEnd: (): void => {
    console.groupEnd();
  },
  table: (data?: unknown): void => {
    console.table(data);
  },
};
